import LABEL from "../../business-const/Label/Label"



const tipoPlanejamentoSucessorioList = (listaCompleta) => {

   const tipoPlanejamentoSucessorioListAux = [
      {
         id: 'H',
         descricao: 'Holding',
         ordem: 10,
      },
      {
         id: 'T',
         descricao: 'Trust',
         ordem: 20,
      },
      //{
      //   id: 'S',
      //   descricao: 'Seguro de Vida',
      //   ordem: 30,
      //},
      //{
      //   id: 'P',
      //   descricao: 'Previdência Privada',
      //   ordem: 40,
      //},
   ]

   if (!listaCompleta) {

        tipoPlanejamentoSucessorioListAux.push(
            {
               id: '',
               descricao: LABEL.naoInformar,
               ordem: 50,
            },
        )
   }

   if (listaCompleta) {

        tipoPlanejamentoSucessorioListAux.push(
            {
                id: 'N', // HARDCODEBACKEND.idTipoPlanejamentoSucessorioNaoInformado      
                descricao: 'Não Informado',
                ordem: 90,
            },
        )
    }

   return tipoPlanejamentoSucessorioListAux
}
 
export default tipoPlanejamentoSucessorioList